export const BOILER_TYPE_GROUND = "au_sol" as const;
export const BOILER_TYPE_WALL = "murale" as const;

export type BoilerTypeValue =
    | typeof BOILER_TYPE_GROUND
    | typeof BOILER_TYPE_WALL;

export const BOILER_TYPE_VALUES: BoilerTypeValue[] = [
    BOILER_TYPE_GROUND,
    BOILER_TYPE_WALL,
];

export const sanitizeBoilerTypeArray = (value: unknown): BoilerTypeValue[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    return value.filter(
        (item): item is BoilerTypeValue =>
            item === BOILER_TYPE_GROUND || item === BOILER_TYPE_WALL
    );
};

export const boilerTypeArrayToApiNumber = (value: unknown): number | unknown => {
    if (!Array.isArray(value)) {
        return value;
    }

    const boilerTypes = sanitizeBoilerTypeArray(value);
    const hasGround = boilerTypes.includes(BOILER_TYPE_GROUND);
    const hasWall = boilerTypes.includes(BOILER_TYPE_WALL);

    if (hasGround && hasWall) return 0;
    if (hasGround) return 1;
    if (hasWall) return 2;

    return 0;
};

export const boilerTypeToArray = (value: unknown): BoilerTypeValue[] => {
    if (Array.isArray(value)) {
        return sanitizeBoilerTypeArray(value);
    }

    if (value === 1) return [BOILER_TYPE_GROUND];
    if (value === 2) return [BOILER_TYPE_WALL];
    if (value === 0) return [BOILER_TYPE_GROUND, BOILER_TYPE_WALL];

    return [];
};
